import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e5ec686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps-4 my-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "table table-striped mb-5" }
const _hoisted_5 = { class: "d-block mt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { width: "200" }, null, -1))
const _hoisted_7 = {
  colspan: "50",
  class: "groupName"
}
const _hoisted_8 = {
  key: 0,
  class: "my-3"
}
const _hoisted_9 = {
  key: 1,
  class: "my-3"
}
const _hoisted_10 = {
  key: 2,
  class: "my-3"
}
const _hoisted_11 = {
  key: 3,
  class: "my-3"
}
const _hoisted_12 = {
  key: 4,
  class: "my-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mt-1 fs_12" }, "(CO2e g)", -1))
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end text-end"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "total" }
const _hoisted_19 = { class: "py-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "py-2" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "py-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          type: "h5",
          localizedKey: "Production Process",
          text: "Production Process"
        }),
        (_ctx.isLeather)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              class: "d-block fs_12",
              localizedKey: "(The following CO2 emissions will not be counted in the total, as they are included in leather use)",
              text: "(The following CO2 emissions will not be counted in the total, as they are included in leather use)"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_3,
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Process",
              text: "Process"
            })
          ]),
          _createElementVNode("th", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Properties",
              text: "Properties"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroupedMaterials, (obj) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "text-center",
              key: obj.name
            }, [
              _createTextVNode(_toDisplayString(obj.name) + " ", 1),
              _createElementVNode("label", _hoisted_5, _toDisplayString(obj.productionCountry), 1)
            ]))
          }), 128)),
          _hoisted_6
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedByProductionGroup, (processesByName, group) => {
        return (_openBlock(), _createElementBlock("tbody", { key: group }, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("strong", null, _toDisplayString(group), 1)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processesByName, (processData, processName) => {
            return (_openBlock(), _createElementBlock("tr", { key: processName }, [
              _createElementVNode("td", null, _toDisplayString(processName), 1),
              _createElementVNode("td", null, [
                (_ctx.checkIfIsSingleG(processData.processes[0].emissionCalculation))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.grams.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.grams.value) + " (g)", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkIfIsWattMin(processData.processes[0].emissionCalculation))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.minutes.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.minutes.value) + " (min)", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkIfIsGWattMinOrVariant(processData.processes[0].emissionCalculation))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.grams.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.grams.value) + " (g)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.minutes.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.minutes.value) + " (min)", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkIfIsGTripleWattMin(processData.processes[0].emissionCalculation))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.grams.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.grams.value) + " (g)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt2.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt2.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt3.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt3.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.minutes.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.minutes.value) + " (min)", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkIfIsGWattMinM3(processData.processes[0].emissionCalculation))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.grams.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.grams.value) + " (g)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.watt.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.watt.value) + " (watt)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.minutes.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.minutes.value) + " (min)", 1),
                      _createElementVNode("li", null, _toDisplayString(processData.processes[0].emissionCalculation.m3.key) + ": " + _toDisplayString(processData.processes[0].emissionCalculation.m3.value) + " (m3)", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroupedMaterials, (obj) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: "text-center",
                  key: obj.name
                }, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.approximation(processData.materials.filter(x => x.name == obj.name)[0].cO2e)) + " ", 1),
                    _hoisted_13
                  ])
                ]))
              }), 128)),
              _createElementVNode("td", null, [
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn btn-secondary me-1",
                        onClick: ($event: any) => (_ctx.openEditModal(processName, processData.processes[0].emissionCalculation))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Edit",
                          text: "Edit"
                        })
                      ], 8, _hoisted_15),
                      (processData.materials.filter(x => x.cO2e == 0).length == 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary",
                            onClick: ($event: any) => (_ctx.removeProcess(processName, processData.processes[0].emissionCalculation))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Remove",
                              text: "Remove"
                            })
                          ], 8, _hoisted_16))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-tertiary me-1",
                            onClick: ($event: any) => (_ctx.backToDefaultValues(processName))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Default",
                              text: "Default"
                            })
                          ], 8, _hoisted_17))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("tr", _hoisted_18, [
        _createElementVNode("td", _hoisted_19, [
          _createElementVNode("strong", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Total (CO2e g)",
              text: "Total (CO2e g)"
            })
          ])
        ]),
        _hoisted_20,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroupedMaterials, (material) => {
          return (_openBlock(), _createElementBlock("td", {
            class: "py-2 text-center",
            key: material.name
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(material.cO2e)), 1)
          ]))
        }), 128)),
        _hoisted_21
      ])
    ])
  ]))
}